// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"1d6741aa","115":"3d0068a7","545":"d2009bfb","608":"954f6fb9","686":"d4a74676","728":"34447921","801":"1d6741aa"}[chunkId] + ".chunk.css";
};